import { render, staticRenderFns } from "./employeelist.vue?vue&type=template&id=207d2918&scoped=true&"
import script from "./employeelist.vue?vue&type=script&lang=js&"
export * from "./employeelist.vue?vue&type=script&lang=js&"
import style0 from "./employeelist.vue?vue&type=style&index=0&id=207d2918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d2918",
  null
  
)

export default component.exports